export class ForgotPasswordInput {
    public email: string = '';
}
